<div style="transform: scale(0.75);">
<div class="primary-container">
  <div class="row" style="width: 100%; text-align: center;">
    <div class="col-md-4"></div>
    <div class="col-md-4">
      <h3>Work Order</h3>
    </div>
    <div class="d-flex justify-content-end mb-2 col-md-4">
      <div class="btn-group" role="group" aria-label="Basic example">
        <button class="btn btn-outline-secondary">
          <i class="fal me-1 fa-pencil"></i>
        </button>
        <button class="btn btn-outline-primary">
          <i class="fal me-1 fa-print"></i>
        </button>
        <button class="btn btn-outline-secondary">
          <i class="fas fa-times"></i>
        </button>
      </div>
    </div>
  </div>
  <div class="row" style="width: 100%;">
    <div class="col-md-1"></div>
    <div class="col-md-1">
      <label>WO#</label>
    </div>
    <div class="col-md-2">
      <b>123456</b>
    </div>
    <div class="col-md-1"></div>
    <div class="col-md-6">
      <input type="checkbox" class="form-check-input me-2" style="margin: 0.75em;" value="true">
      <label class="form-check-label">High Priority</label>
    </div>
  </div>
  <div class="row" style="width: 100%;">
    <div class="col-md-1"></div>
    <div class="col-md-1">
      <label>STATUS</label>
    </div>
    <div class="col-md-4">
      <select class="form-select" aria-label="Default select example">
        <option selected>Assigned</option>
        <option value="1">In Progress</option>
        <option value="2">Completed</option>
      </select>
    </div>
  </div>
  <div class="row mt-3" style="width: 100%; text-align: center;">
    <div class="col-md-12">
      <h5>Customer / Service Address</h5>
    </div>
  </div>
  <div class="row" style="width: 100%;">
    <div class="col-md-1"></div>
    <div class="col-md-1">
      <label>SEARCH</label>
    </div>
    <div class="col-md-6">
      <div class="input-group mb-3">
        <input type="text" class="form-control" placeholder="Search...">
        <button class="btn btn-outline-secondary" type="button" id="button-addon2"><i class="fas fa-search"></i></button>
      </div>
    </div>
  </div>
  <div class="row" style="width: 100%;">
    <div class="col-md-1"></div>
    <div class="col-md-1">
      <label>ACCT #</label>
    </div>
    <div class="col-md-2">
      <b>234567</b>
    </div>
    <div class="col-md-1">
      <label>Name</label>
    </div>
    <div class="col-md-6">
      <input type="text" class="form-control" placeholder="Customer Name" value="John Doe" readonly>
    </div>
  </div>
  <div class="row" style="width: 100%;">
    <div class="col-md-1"></div>
    <div class="col-md-3">
      <label>SERVICE ADDRESS</label>
    </div>
    <div class="col-md-7">
      <input type="text" class="form-control" placeholder="Service Address" value="123 Main St" readonly>
    </div>
  </div>
  <div class="row" style="width: 100%;">
    <div class="col-md-1"></div>
    <div class="col-md-1">
      <label>CITY</label>
    </div>
    <div class="col-md-4">
      <input type="text" class="form-control" placeholder="City" value="Anytown" readonly>
    </div>
    <div class="col-md-1">
      <label>STATE</label>
    </div>
    <div class="col-md-1">
      <input type="text" class="form-control" placeholder="State" value="PA" readonly>
    </div>
    <div class="col-md-1">
      <label>ZIP</label>
    </div>
    <div class="col-md-2">
      <input type="text" class="form-control" placeholder="Zip Code" value="12345" readonly>
    </div>
  </div>
  <div class="row mt-3" style="width: 100%; text-align: center;">
    <div class="col-md-12">
      <h5>Request Information</h5>
    </div>
  </div>
  <div class="row" style="width: 100%;">
    <div class="col-md-1"></div>
    <div class="col-md-2">
      <label>REQUEST DATE</label>
    </div>
    <div class="col-md-3">
      <input type="text" class="form-control" placeholder="Request Date" value="2023-10-01" readonly>
    </div>
    <div class="col-md-2">
      <label>REQUESTED VIA</label>
    </div>
    <div class="col-md-3">
      <select class="form-select" aria-label="Default select example">
        <option selected>Phone</option>
        <option value="1">In Person</option>
        <option value="2">Email</option>
      </select>
    </div>
  </div>
  <div class="row" style="width: 100%;">
    <div class="col-md-1"></div>
    <div class="col-md-3">
      <label>REQUESTER NAME</label>
    </div>
    <div class="col-md-7">
      <input type="text" class="form-control" placeholder="Requester Name" value="John Doe" readonly>
    </div>
  </div>
  <div class="row" style="width: 100%;">
    <div class="col-md-1"></div>
    <div class="col-md-2">
      <label>PHONE</label>
    </div>
    <div class="col-md-3">
      <input type="text" class="form-control" placeholder="Phone Number" value="(555) 555-1234" readonly>
    </div>
    <div class="col-md-2">
      <label>EMAIL</label>
    </div>
    <div class="col-md-3">
      <input type="text" class="form-control" placeholder="Email Address" value="john.doe@example.com" readonly>
    </div>
  </div>
  <div class="row" style="width: 100%;">
    <div class="col-md-1"></div>
    <div class="col-md-4">
      <label>PREFERRED CONTACT METHOD</label>
    </div>
    <div class="col-md-3">
      <select class="form-select" aria-label="Default select example">
        <option selected>Call</option>
        <option value="1">Text</option>
        <option value="2">Email</option>
      </select>
    </div>
  </div>
  <div class="row" style="width: 100%;">
    <div class="col-md-1"></div>
    <div class="col-md-4">
      <label>CONTAINER TYPE</label>
    </div>
    <div class="col-md-3">
      <select class="form-select" aria-label="Default select example">
        <option selected>Refuse</option>
        <option value="1">Recycling</option>
        <option value="2">Yard Waste</option>
      </select>
    </div>
  </div>
  <div class="row" style="width: 100%;">
    <div class="col-md-1"></div>
    <div class="col-md-4">
      <label>CONTAINER SIZE</label>
    </div>
    <div class="col-md-3">
      <select class="form-select" aria-label="Default select example">
        <option selected>35</option>
        <option value="1">65</option>
        <option value="2">95</option>
      </select>
    </div>
  </div>
  <div class="row" style="width: 100%;">
    <div class="col-md-1"></div>
    <div class="col-md-4">
      <label>ACTION REQUESTED</label>
    </div>
    <div class="col-md-3">
      <select class="form-select" aria-label="Default select example">
        <option selected>Replacement</option>
        <option value="1">Repair</option>
        <option value="2">Other</option>
      </select>
    </div>
  </div>
  <div class="row" style="width: 100%;">
    <div class="col-md-1"></div>
    <div class="col-md-3">
      <label>REQUEST DESCRIPTION</label>
    </div>
    <div class="col-md-7">
      <input type="text" class="form-control" placeholder="Request Description" value="Container needs replacement" readonly>
    </div>
  </div>
  <div class="row mt-3" style="width: 100%; text-align: center;">
    <div class="col-md-12">
      <h5>Container Information</h5>
    </div>
  </div>
  <div class="row" style="width: 100%; text-align: center;">
    <div class="col-md-12">
      <b>Old Container</b>
    </div>
  </div>
  <div class="row" style="width: 100%;">
    <div class="col-md-1"></div>
    <div class="col-md-1">
      <label>SERIAL</label>
    </div>
    <div class="col-md-2">
      <input type="text" class="form-control" placeholder="Serial Number" value="SN123456789" readonly>
    </div>
    <div class="col-md-1">
      <label>COLOR</label>
    </div>
    <div class="col-md-2">
      <select class="form-select" aria-label="Default select example">
        <option selected>Black</option>
        <option value="1">Tan</option>
        <option value="2">Green</option>
      </select>
    </div>
    <div class="col-md-1">
      <label>MODEL</label>
    </div>
    <div class="col-md-2">
      <select class="form-select" aria-label="Default select example">
        <option selected>Schaffer</option>
        <option value="1">Cascade</option>
        <option value="2">Otto</option>
      </select>
    </div>
  </div><div class="row" style="width: 100%; text-align: center;">
    <div class="col-md-12">
      <b>New Container</b>
    </div>
  </div>
  <div class="row" style="width: 100%;">
    <div class="col-md-1"></div>
    <div class="col-md-1">
      <label>SERIAL</label>
    </div>
    <div class="col-md-2">
      <input type="text" class="form-control" placeholder="Serial Number" value="SN123456789" readonly>
    </div>
    <div class="col-md-1">
      <label>COLOR</label>
    </div>
    <div class="col-md-2">
      <select class="form-select" aria-label="Default select example">
        <option selected>Black</option>
        <option value="1">Tan</option>
        <option value="2">Green</option>
      </select>
    </div>
    <div class="col-md-1">
      <label>MODEL</label>
    </div>
    <div class="col-md-2">
      <select class="form-select" aria-label="Default select example">
        <option selected>Schaffer</option>
        <option value="1">Cascade</option>
        <option value="2">Otto</option>
      </select>
    </div>
  </div>
</div>
</div>
